import { InjectionToken } from '@angular/core';

// Define and use an InjectionToken object for choosing a provider token for non-class dependencies.
export const APPCUES_ACCOUNT_ID = new InjectionToken<string>('Appcues account id');
